export const MODULE_NAME = 'messages'

export const NUXT_PAGE_MESSAGE_LIST = `${MODULE_NAME}-whatsapp-list`
export const NUXT_PAGE_MESSAGE_DETAIL = `${MODULE_NAME}-whatsapp-detail`
